import React,{useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContextualPaymentRow from "./contextualPaymentRow";
import { createFiscalPayment, deleteFiscalPayment, updateFiscalPayment } from "../../../../store/actions/precog/fiscalPayments";

/**
 *
 * @param {totalSelection} il totale dettato dall'eventuale selezione di righe
 */
const NewRecordForm = ({draftId, totalInvoice, totalSelection}) => {
  const dispatch = useDispatch();
  const [contextualPayments, setContextualPayments] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [isError, setIsError] = useState(false);
  // on remove don't onChange fired
  const [isRemoved, setIsRemoved] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  // const [totalSumRows, setTotalSumRows] = useState(0);

  const precog = useSelector(state => state.precog);
  const precogFiscalPayments = precog?.fiscalPayments?.savedList;
  const precogFiscalPaymentsStatus = precog?.fiscalPayments?.status;

  /** Creo la lista da precogFiscalPayments escludendo quelli con registeredPaymentId
   * (sono gli id della tabella)
   * */
  useEffect(() => {
    if (precogFiscalPaymentsStatus.started) return;
    const arrayFiscalPaymentsPreSaved = [];
    const filteredFiscalPayments = precogFiscalPayments?.filter(el => !el.registeredPaymentId);
    /** TODO Attenzione se esistono registeredPaymentId e totalSelection è nullo non è possibile*/
    if (filteredFiscalPayments?.length === 0) {
      
      setContextualPayments([{
        total: totalInvoice - totalSelection,
        conto: null        
      }]);
      // setTotalSumRows(totalInvoice - totalSelection)
    } else {
      filteredFiscalPayments.forEach(element => {
        
        arrayFiscalPaymentsPreSaved.push({
          uuid: element.uuid,
          conto: element.account,
          total: element.amount,
          type: element.type
        });
      });
      setContextualPayments(arrayFiscalPaymentsPreSaved);
      const sumSelectedAndForm = (calculateSumFormRow(arrayFiscalPaymentsPreSaved) + totalSelection);
      // setTotalSumRows(totalInvoice - sumSelectedAndForm);
      setIsError(totalInvoice - sumSelectedAndForm < 0);
    }
  }, [precogFiscalPayments]);

  useEffect(() => {

    const sumSelectedAndForm = (calculateSumFormRow(contextualPayments) + totalSelection);
    // setTotalSumRows(totalInvoice - sumSelectedAndForm);
    setIsError(totalInvoice - sumSelectedAndForm < 0);
  }, [totalSelection, contextualPayments]);

  /*
  useEffect(() => {
    if(precogFiscalPaymentsStatus.started) return;
    const arrayContextuals = [...contextualPayments];
    if (contextualPayments.length === 0 && !isRemoved){
      arrayContextuals.push({
        total: totalInvoice - totalSelection,
        conto: null
      });
      setContextualPayments(arrayContextuals);
      setTotalSumRows(totalInvoice);
    }
  }, [contextualPayments, totalInvoice, totalSelection]);

  useEffect(() => {
    const arrayFiscalPaymentsPreSaved = [];
    const filteredFiscalPayments = precogFiscalPayments?.filter(el => !el.registeredPaymentId);

    if(filteredFiscalPayments?.length === 0) {
      setContextualPayments([{
        total: totalInvoice - totalSelection,
        conto: null
      }])
      setTotalSumRows(totalInvoice - totalSelection)
    } else{
      filteredFiscalPayments.forEach(element => {
        arrayFiscalPaymentsPreSaved.push({
          uuid: element.uuid,
          conto: element.account,
          total: element.amount
        })
      });
      setContextualPayments(arrayFiscalPaymentsPreSaved)
      setTotalSumRows(totalInvoice - (calculateSumFormRow(arrayFiscalPaymentsPreSaved) + totalSelection))
    }
  }, [precogFiscalPayments, totalSelection])
  */

  const removeItems = (indexToRemove) => {
    const cloneArr = [...contextualPayments];

    if (cloneArr?.[indexToRemove]?.uuid){
      dispatch(deleteFiscalPayment(draftId, cloneArr[indexToRemove]?.uuid)).then(res => {
        // ricarico la get altrimenti dà comportamenti strani
        cloneArr.splice(indexToRemove,1);
        setContextualPayments(cloneArr);
        // setTotalSumRows(calculateSumFormRow(cloneArr) + totalSelection);
      });
    } else {
      setIsRemoved(true);
      cloneArr.splice(indexToRemove,1);
      setContextualPayments(cloneArr);
      // setTotalSumRows(calculateSumFormRow(cloneArr) + totalSelection);
    }
  };

  const changeContextualPayments =
    (
      index, type, value
    ) => {
      if (isRemoved || !isUpdate) {
        setIsRemoved(false);
        setIsUpdate(true);
      }
      const cloneContextuals = [...contextualPayments];
      if (cloneContextuals.length > 0 ){
        cloneContextuals[index][type] = value;
      } else {
        cloneContextuals.push({
          [type]: value
        });
      }

      //  if(type === "total") setTotalSumRows(calculateSumFormRow(cloneContextuals) + totalSelection);
      // in presenza di uuid stiamo andando in modifica

      if (cloneContextuals[index].uuid){
        dispatch(updateFiscalPayment(draftId, cloneContextuals[index]));
      } else {
        setContextualPayments(cloneContextuals);
        dispatch(createFiscalPayment(draftId, cloneContextuals[index])).then((res) => {
          cloneContextuals[index>-1 ? index : 0].uuid = res;
        }).catch(err =>
          console.log("errore"));
      }
    };

  const calculateSumFormRow = (arrayRows) => {

    return Math.abs(arrayRows.reduce((a, b) => (a + parseFloat(b.total ? b.total : 0)), 0));
  };

  const addFormRow = () => {
    const cloneArrayPayments = [...contextualPayments];

    const summedRows = calculateSumFormRow(cloneArrayPayments);
    const totalSelectedAndForm = (totalSelection + summedRows);
    const residual = totalInvoice > totalSelectedAndForm ? totalInvoice - totalSelectedAndForm : 0;
    cloneArrayPayments.push({total: residual,
      conto: null});
    setContextualPayments(cloneArrayPayments);
    setIsRemoved(false);
  };

  return precogFiscalPaymentsStatus.started ?
    (
      <div style={{margin: "16px 0", padding: 0}}> <FontAwesomeIcon icon={["far", "spinner"]} style={{
        color: "#0090d1",
        fontSize: "24px",
        cursor: "pointer"
      }} spin /></div>
    ) :
    (
      <>
        {
          contextualPayments?.map((el, index) => {
            return <ContextualPaymentRow
              {...el} indexRow={index}
              key={`contextualPaymentRow_${index}`}
              changeContextualPayments={changeContextualPayments}
              showPopover={showPopover}
              setShowPopover={setShowPopover}
              isError={isError}
              removeItems={removeItems}
              conto = {el?.conto || ""}
              isTrashIcon={contextualPayments.length > 1 || el?.conto}
              isLoading = {precogFiscalPaymentsStatus.saving}
            />;
          })
        }
        <div tabIndex="0" role="button" aria-pressed="false"
          className="rowContextualPaymentAdd"
          onClick={addFormRow}
          onKeyDown={e => e.keyCode === 13 ? addFormRow() : null}
          style={{margin: "16px 0", padding: 0}}
        >
          <FontAwesomeIcon icon={["far", "plus-circle"]} />
        </div>
      </>
    );
};

export default NewRecordForm;